import NSPDatePicker from '@components/ui/NSPDatepicker';
import { Form, Select, Row, Col, InputNumber } from 'antd';

const CoreInfoReplacementMeterInfoSection = ({ form, disabled = false }) => (
  <Row gutter={16}>
    <Col span={8}>
      <Form.Item label="Meter Swap" name="meterSwap" data-testid="meter-swap-field">
        <Select
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' },
          ]}
        />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label="Final Out Meter Read (KWH)" name="final_meter_read" data-testid="final-meter-read-field">
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label="Final Out Meter Read Date" name="final_read_date" data-testid="final-read-date-field">
        <NSPDatePicker style={{ width: '100%' }} disabled={disabled} />
      </Form.Item>
    </Col>
  </Row>
);

export default CoreInfoReplacementMeterInfoSection;
